import {
  HeartPulse, Cpu, FlaskConical, Landmark, Shield, Wallet, Scale, Rocket,
  GraduationCap, Palette, HandHeart, Plane, Cog,
} from "lucide-react";

const FAMILIES = [
  { icon: HeartPulse, label: "Medicine & Healthcare" },
  { icon: Cog, label: "Engineering" },
  { icon: Cpu, label: "Technology, Software & AI" },
  { icon: FlaskConical, label: "Scientific Research" },
  { icon: Wallet, label: "Finance & Banking" },
  { icon: Landmark, label: "Civil Services & Public Admin" },
  { icon: Shield, label: "Defence, Police & Security" },
  { icon: Scale, label: "Law & Judiciary" },
  { icon: GraduationCap, label: "Education" },
  { icon: HandHeart, label: "Social Work & Community Dev." },
  { icon: Palette, label: "Design & Creative Industries" },
  { icon: Plane, label: "Aviation & Maritime" },
  { icon: Rocket, label: "Entrepreneurship & Startups" },
];

export default function CareerUniverse() {
  return (
    <section id="career-universe" className="relative overflow-hidden bg-gradient-to-br from-[#0B0F1E] via-[#131C36] to-[#0B0F1E] py-24 px-6">
      <div className="absolute -top-24 right-0 h-80 w-80 rounded-full bg-cyan-500/15 blur-[100px]" />
      <div className="max-w-6xl mx-auto relative">
        <p className="text-xs uppercase tracking-[0.2em] font-medium text-cyan-400 mb-3 text-center">The Career Universe</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white text-center max-w-3xl mx-auto mb-4">
          57+ Career Families Mapped Today, Built to Reach 800–1,200 Occupations
        </h2>
        <p className="text-sm text-slate-400 text-center max-w-2xl mx-auto mb-16">
          Includes India-specific pathways (UPSC, Defence, Banking & PSU, State Government) alongside global
          professions — matched to where you're building your future from.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {FAMILIES.map((f) => (
            <div key={f.label} className="rounded-xl border border-slate-800 bg-slate-900/60 p-5 flex flex-col gap-3 hover:border-indigo-500/50 transition-colors">
              <f.icon className="h-6 w-6 text-indigo-400" />
              <span className="text-sm text-slate-300 leading-snug">{f.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
